module.exports = __webpack_public_path__ + "img/iconDevice.7f0687cd.svg";